/* global moment */
var ctrlopt = ctrlopt,
  site = site || {},
  FB = FB || '';

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings.globals_variables || {};
  var oab_date_time_override = settings.oab_date_time_override || 0;
  var start_day = settings.appointment_booking_datepicker_start_day
    ? settings.appointment_booking_datepicker_start_day
    : 0;
  var oab_date_override = settings.oab_override_date_format ? settings.oab_override_date_format : 0;
  var oab_show_week_last = settings.oab_show_week_last || 0;
  var time_interval =
    $('.appointment-select .col-heads').data('time-interval') ||
    settings.appointment_booking_time_interval;
  var allow_priced_services = settings.allow_priced_services ? settings.allow_priced_services : 0;
  var OAB_price_override = settings.OAB_override_price_format
    ? settings.OAB_override_price_format
    : 0;
  var currencySymbol = settings.OAB_price_currency ? settings.OAB_price_currency : '$';
  var commercial_agreement = settings.appointment_booking_commercial_terms
    ? settings.appointment_booking_commercial_terms
    : 0;
  var require_cpf = settings.appointment_booking_cpf_brazil ? 1 : 0;
  var oab_year_first = settings.oab_year_first || 0;
  var kr_day_month_format = settings.kr_day_month_format || 0;
  var oab_show_month_after_year = settings.oab_show_month_after_year || 0;
  var oab_show_year_suffix = settings.oab_show_year_suffix || 0;
  var oab_legal_statement_promotions = settings.oab_legal_statement_promotions || 0;
  var do_not_submit_sms_pg_form = settings.do_not_submit_sms_pg_form || 0;
  var oab_use_countrycode = settings.oab_use_countrycode || 0;
  var oab_year_suffix = settings.oab_year_suffix ? settings.oab_year_suffix : '';
  var oab_month_suffix = settings.oab_month_suffix ? settings.oab_month_suffix : '';
  var oab_day_suffix = settings.oab_day_suffix ? settings.oab_day_suffix : '';
  var oab_date_time_dayname_day_month = settings.oab_date_time_dayname_day_month || 0;
  var oab_use_cms_for_mb_calendar_names = settings.oab_use_cms_for_mb_calendar_names || 0;

  /* optional day number override function used when we need to generate calendar table starting from monday; when global var start_day is not defined, output value is untouched */
  function startDayShift(day_nr) {
    day_nr = day_nr - start_day;
    if (day_nr == -1) {
      day_nr = 6;
    }

    return day_nr;
  }

  /* helper function to correctly validate brazilian CPF number, source: https://gist.github.com/vazgabriel/ca1266fae95a6c1d6fb63f345b826f96 */
  function validateCpf(cpfString) {
    var validated = false;

    if (cpfString.length !== 14 && cpfString.length !== 11) {
      return validated;
    }
    if (cpfString.length === 14) {
      cpfString = cpfString.replace('.', '');
      cpfString = cpfString.replace('.', '');
      cpfString = cpfString.replace('-', '');
    }
    var sum = 0,
      rest = 0;

    if (cpfString === '00000000000') {
      return validated;
    }
    for (var i = 1; i <= 9; ++i) {
      sum += parseInt(cpfString.substring(i - 1, i)) * (11 - i);
    }
    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) {
      rest = 0;
    }
    if (rest !== parseInt(cpfString.substring(9, 10))) {
      return validated;
    }
    validated = true;

    return validated;
  }
  /* Concrete View */
  apptBook.AppointmentSelectSection = function (container) {
    apptBook.AppointmentSelectSection.superclass.constructor.call(this);
    this.id = 'appointments';
    this.jqBod = $('body');
    this.container = container;
    this.servContainer = container.find('.services');
    this.serviceTmpl = this.servContainer.find('.service').remove();
    this.changeServices = container.find('#change-services-link');
    this.backTo = container.find('.back-to-link');
    this.minLabel = this.servContainer.attr('data-time-label');
    this.locSelect = container.find('select.location-select');
    this.artContainer = container.find('.artist-select-container');
    this.artSelect = this.artContainer.find('select.artist-select');
    this.artAnyValue = this.artSelect.attr('data-artist-any-value');
    this.apptContainer = container.find('.appointment-select');
    this.signInContainer = container.find('.sign-in-container');
    this.bookContainer = container.find('.book-appt-container');
    this.confContainer = container.find('.confirm-container');
    this.totalElem = this.confContainer.find('.total-time');
    this.totalText = this.totalElem.html();
    this.startOver = this.bookContainer.find('.start-over');
    this.selErrOverlay = container.find('.appt-book-services-overlay').remove();
    this.bookConflictOverlay = container.find('.appt-book-book-conflict-overlay').remove();
    this.calendarId = '0';
    this.appointmentId = null;
    this.appointmentTime = null;
    this.totalTime = 0;
    this.totalTimeWithPadding = 0;
    this.totalCost = 0;
    this.serviceIds = [];
    this.stores = {};
    this.updateMode = false;
    this.apptContainer = container.find('.appointment-select');
    this.calHead = this.apptContainer.find('.calendar-head');
    this.calDayOfWeekFormat = this.calHead.attr('data-cal-DOW-date-format') || '';
  };

  ctrlopt.extend(apptBook.AppointmentSelectSection, apptBook.AbstractSection);

  apptBook.AppointmentSelectSection.prototype.onUpdate = function (data) {
    var servs,
      servObj,
      hasCounter = false,
      hasCounters = false,
      me = this;

    this.serviceIds = [];
    this.totalTime = 0;
    this.totalCost = 0;
    this.updateMode = false;

    function runUpdate() {
      if (hasCounter && hasCounters) {
        me.buildServices();
        me.buildLocation();
        me.buildArtists();
        if (!me.initialized) {
          me.buildApptSelect();
          me.initialized = true;
        } else {
          me.calModel.update({
            date: new Date(),
            calendarId: me.calendarId,
            counterId: me.counterId,
            serviceIds: me.serviceIds,
            hilite: true
          });
        }

        me.buildBookAppt();
      }
    }

    function processUpdate() {
      if (data.params.appointmentId) {
        me.model.getAppointment(
          data.params.appointmentId,
          function (apptData) {
            me.appointmentData = apptData;
            me.updateMode = true;
            me.counterId = me.appointmentData.counter_id;
            me.calendarId = me.appointmentData.calendar_id;
            me.servicesData = [];
            me.appointmentId = apptData.id;
            me.appointmentTime = apptData.start_time;

            servs = me.appointmentData.services;

            for (var i = 0, len = servs.length; i < len; i += 1) {
              servObj = servs[i];
              me.servicesData.push({
                serviceId: servObj.id,
                serviceDurationWithPadding: servObj.total_duration_with_padding,
                serviceDuration: servObj.total_duration,
                serviceName: servObj.name
              });

              me.serviceIds.push(servObj.id);
            }

            me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
              me.counterData = data;
              hasCounter = true;
              runUpdate();
            });
          },
          function () {
            // If there is an error retrieving appointment id, go to beginning of APP
            var myUrl = [location.protocol, '//', location.host, location.pathname].join('');

            window.location = myUrl;
          }
        );
      } else {
        if (me.counterId !== data.params.counterId) {
          me.calendarId = '0';
        }
        if (data.params.updateMode) {
          me.updateMode = true;
          me.calendarId = '0';
        } else {
          me.updateMode = false;
        }
        me.counterId = data.params.counterId;
        me.servicesData = data.params.services;
        for (var i = 0, len = me.servicesData.length; i < len; i += 1) {
          me.serviceIds.push(me.servicesData[i].serviceId);
        }

        me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
          me.counterData = data;
          hasCounter = true;
          runUpdate();
        });
      }

      me.model.fetchCountersData({ service_id: this.serviceIds }, function (data) {
        me.countersData = data;
        hasCounters = true;
        runUpdate();
      });
    }

    if (data.sectionId === this.id) {
      generic.jsonrpc.fetch({
        method: 'user.json',
        params: [],
        onSuccess: function (jsonRpcResponse) {
          me.userData = jsonRpcResponse.getValue();
          processUpdate();
        },
        onFailure: function (jsonRpcResponse) {
          me.userData = null;
          processUpdate();
        }
      });
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildServices = function () {
    var myTmpl,
      sData,
      me = this;

    this.servContainer.find('.service').remove();
    for (var i = 0, len = this.servicesData.length; i < len; i += 1) {
      sData = this.servicesData[i];
      myTmpl = this.serviceTmpl.clone();
      this.servContainer.append(myTmpl);

      var price = OAB_price_override
        ? sData.servicePrice + currencySymbol
        : currencySymbol + '\xA0' + sData.servicePrice;
      var time = sData.serviceDuration + ' ' + this.minLabel;

      if (site.client.isMobile) {
        if (parseInt(sData.servicePrice) && allow_priced_services) {
          myTmpl.find('.service-head').text(sData.serviceName + ' (' + time + ' /' + price + ')');
        } else {
          myTmpl.find('.service-head').text(sData.serviceName + ' (' + time + ')');
        }
      } else {
        myTmpl.find('.service-head').text(sData.serviceName);
        myTmpl.find('.selection-time').text(time);
        if (parseInt(sData.servicePrice) && allow_priced_services) {
          myTmpl.find('.selection-price').text(price);
          myTmpl.find('.selection-selector').addClass('priced');
        }
      }

      this.totalTime += parseInt(sData.serviceDuration);
      this.totalTimeWithPadding += parseInt(sData.serviceDurationWithPadding);
      this.totalCost += parseInt(sData.servicePrice);
      // this.serviceIds.push(sData.serviceId);

      function changeServSel(e) {
        e.preventDefault();

        var upObj = {
          sectionId: 'services',
          params: {
            sectionId: me.id,
            counterId: me.counterId,
            updateMode: me.updateMode
          }
        };

        me.model.update(upObj);
      }

      this.changeServices.off('click');
      this.changeServices.click(changeServSel);
      this.backTo.off('click');
      this.backTo.click(changeServSel);
    }

    if (!site.client.isMobile && this.servicesData.length > 1) {
      apptBook.equalHeights(this.servContainer.find('.service-head'));
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildLocation = function () {
    var me = this;
    // To determine if this appointment is virtual, see if the first service assigned to it is virtual.
    var apptServ = me.model.servicesData.filter(function (ele) {
      return parseInt(ele.id) === parseInt(me.servicesData[0].serviceId);
    })[0];
    var hasVirtual = parseInt(apptServ.virtual);

    if (hasVirtual) {
      this.container.find('.counter-select-container').addClass('virtual__location__counter');
      this.container.find('.location-select').addClass('hidden');
      this.container.find('.js-virtual-location-container').removeClass('hidden');
    }
    this.locSelect.find('option').remove();
    this.stores = {};
    var virtualList = [];
    var virtualIds = [];

    for (var j = 0, serviceLen = this.model.servicesData.length; j < serviceLen; j += 1) {
      if (this.model.servicesData[j].virtual !== '0') {
        virtualList.push(this.model.servicesData[j].id);
      }
    }

    for (var i = 0, len = this.countersData.length; i < len; i += 1) {
      var serviceIds = this.countersData[i].service_ids;

      if (Array.isArray(serviceIds)) {
        virtualIds = serviceIds.filter(function (e) {
          return virtualList.indexOf(e) !== -1;
        });
      }
      if (typeof virtualIds !== 'undefined' && !virtualIds.length) {
        var storeName = this.countersData[i].name,
          optionText =
            this.countersData[i].town + ' - ' + storeName + ', ' + this.countersData[i].address1,
          optionValue = this.countersData[i].id,
          newOption = $('<option value="' + optionValue + '">' + optionText + '</option>'),
          storeNum = this.countersData[i].store_no;

        this.stores[optionValue] = {
          store: storeNum,
          name: storeName
        };

        if (optionValue === this.counterId) {
          newOption.attr('selected', 'selected');
        }
        this.locSelect.append(newOption);
      }
      /* if (this.countersData[i].service_ids.length > 0 && this.countersData[i].calendars.length > 0) {
        this.locSelect.append(newOption);
      }*/
    }

    site.util.refreshSelectBoxes(me.container.find('.selectbox'));

    function onLocChange(e) {
      var counterId = this.value,
        upObj = {
          sectionId: 'appointments',
          params: {
            counterId: counterId,
            services: me.servicesData,
            updateMode: me.updateMode
          }
        };

      if (counterId !== me.counterId) {
        me.model.update(upObj);
        site?.track?.evtLink && site.track.evtLink({
          event_name: 'appointmentBooking_reselectLocation',
          event_category: 'appointment booking',
          event_action: 'reselect location',
          event_label: me.stores[counterId].store + ' - ' + me.stores[counterId].name
        });
      }
    }
    this.locSelect.off('change'); // remove this first just in case we have already been to this screen
    this.locSelect.on('change', onLocChange);
  };

  apptBook.AppointmentSelectSection.prototype.buildArtists = function () {
    var me = this,
      calData = this.counterData.calendars;

    // this.artContainer.css('display','block');
    this.artContainer.show();
    this.artSelect.find('option').remove();
    if (!calData || !calData.length) {
      this.launchSelErrOverlay();
      // this.artContainer.css('display','none');
      this.artContainer.hide();
    } else if (calData.length <= 1) {
      this.artContainer.hide();
    } else {
      for (var i = 0, len = calData.length; i < len; i += 1) {
        if (calData[i].public_name === 'Any' && this.artAnyValue) {
          calData[i].public_name = this.artAnyValue;
        }
        var optionText = calData[i].public_name,
          optionValue = calData[i].id,
          newOption = $('<option value="' + optionValue + '">' + optionText + '</option>');

        if (optionValue === this.calendarId) {
          newOption.attr('selected', 'selected');
        }

        this.artSelect.append(newOption);
      }

      site.util.refreshSelectBoxes(me.container.find('.selectbox'));
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildApptSelect = function () {
    var mOptions,
      vOptions,
      dpOptions,
      calDate,
      calTable,
      calHead,
      cHCont,
      colHeads,
      timeSlotsContainer,
      timeSlotRow,
      monthNames,
      dayNames,
      slotLabels,
      dpTrigger,
      dpField,
      dpOverlay,
      dpCalCont,
      dpCloseBtn,
      dp,
      dpMonthNames,
      dpDayNames,
      CalHeadView,
      CalTimeSlotsView,
      CalDatePicker,
      dpYearSuffix,
      me = this;

    if (site.client.isMobile || $(window).width() < 700) {
      timeSlotsContainer = this.apptContainer.find('table.day');
      calHead = this.apptContainer.find('.calendar-head');
      timeSlotRow = timeSlotsContainer.find('tr').remove().first();
      if ($('.appointment-select .date-picker').data('time-interval')) {
        slotLabels = timeSlotsContainer.attr('data-time-slots_extended').split(',');
      } else {
        slotLabels = timeSlotsContainer.attr('data-time-slots').split(',');
      }
      dp = this.apptContainer.find('.date-picker');
      dpField = this.apptContainer.find('#appt-book-date-picker-field');
      dpCalCont = this.apptContainer.find('#appt-book-datepicker-calendar-container');
      dpMonthNames = dp.attr('data-months').split(',');
      dpDayNames = dp.attr('data-days').split(',');
      time_interval = $('.appointment-select .date-picker').data('time-interval') || time_interval;
      dpYearSuffix = calHead.attr('data-year-suffix');
      CalHeadView = apptBook.CalendarHeaderMobile;
      CalTimeSlotsView = apptBook.CalendarTimeSlotsMobile;
      CalDatePicker = apptBook.CalDatePickerMobile;
      vOptions = {
        container: this.apptContainer,
        timeSlotsContainer: timeSlotsContainer,
        timeSlotRow: timeSlotRow,
        monthNames: monthNames,
        dayNames: dayNames,
        slotLabels: slotLabels,
        calDayOfWeekFormat: this.calDayOfWeekFormat
      };

      dpOptions = {
        calContainer: dpCalCont,
        datepickerField: dpField,
        monthNames: dpMonthNames,
        dayNames: dpDayNames,
        yearSuffix: dpYearSuffix
      };
    } else {
      calTable = this.apptContainer.find('.weekdays');
      calHead = this.apptContainer.find('.calendar-head');
      cHCont = calTable.find('thead.col-heads');
      colHeads = cHCont.find('th');
      timeSlotsContainer = calTable.find('tbody.timeslots');
      timeSlotRow = timeSlotsContainer.find('tr').remove().first();
      monthNames = cHCont.attr('data-months').split(',');
      dayNames = cHCont.attr('data-days').split(',');
      if ($('.appointment-select .col-heads').data('time-interval')) {
        slotLabels = cHCont.attr('data-time-slots_extended').split(',');
      } else {
        slotLabels = cHCont.attr('data-time-slots').split(',');
      }
      dpTrigger = calHead.find('#appt-book-date-picker-trigger');
      dpField = calHead.find('#appt-book-date-picker-field');
      dpOverlay = this.container.find('#appt-book-datepicker-overlay').remove();
      dpCalCont = dpOverlay.find('#appt-book-datepicker-calendar-container');
      dpCloseBtn = dpOverlay.find('.overlay-close');
      dpMonthNames = dpTrigger.attr('data-months').split(',');
      dpDayNames = dpTrigger.attr('data-days').split(',');
      dpYearSuffix = calHead.attr('data-year-suffix');
      /* dpMonthNames = calHead.attr('data-months').split(',');
      dpDayNames = dayNames;*/
      CalHeadView = apptBook.CalendarHeader;
      CalTimeSlotsView = apptBook.CalendarTimeSlots;
      CalDatePicker = apptBook.CalDatePicker;

      vOptions = {
        container: this.apptContainer,
        colHeads: colHeads,
        timeSlotsContainer: timeSlotsContainer,
        timeSlotRow: timeSlotRow,
        monthNames: monthNames,
        dayNames: dayNames,
        slotLabels: slotLabels,
        calDayOfWeekFormat: this.calDayOfWeekFormat
      };

      dpOptions = {
        overlay: dpOverlay,
        closeBtn: dpCloseBtn,
        calContainer: dpCalCont,
        weekContainer: calHead,
        datepickerField: dpField,
        datepickerTrigger: dpTrigger,
        monthNames: dpMonthNames,
        dayNames: dpDayNames,
        yearSuffix: dpYearSuffix,
        jqBod: this.jqBod
      };
    }

    mOptions = {
      dataModel: this.model,
      launchOverlayCallback: this.launchSelErrOverlay.bind(this),
      counterId: this.counterId,
      appointmentDuration: this.totalTime,
      appointmentDurationWithPadding: this.totalTimeWithPadding,
      serviceIds: this.serviceIds
    };

    this.calModel = new apptBook.CalendarModel();
    this.calModel.setData(mOptions);
    this.calTimeSlots = new CalTimeSlotsView(vOptions);
    this.calHeadView = new CalHeadView(calHead);
    this.calTimeSlots.setModel(this.calModel).startObserving();
    this.calHeadView.setModel(this.calModel).startObserving();

    this.datePicker = new CalDatePicker(dpOptions);
    this.datePicker.setModel(this.calModel);

    this.artSelect.on('change', function (e) {
      var calId = this.value,
        calName = this.options[this.selectedIndex].text;

      if (calId !== me.calendarId) {
        me.calModel.update({ calendarId: calId });
        me.calendarId = calId;
      }
    });

    calDate = this.appointmentTime
      ? this.calTimeSlots.convertTimeString(this.appointmentTime)
      : new Date();

    this.calModel.update({
      date: calDate,
      hilite: true,
      calendarId: this.calendarId,
      appointmentTime: this.appointmentTime
    });
  };

  apptBook.AppointmentSelectSection.prototype.buildBookAppt = function () {
    var totText,
      me = this,
      signIn = this.signInContainer.find('#appt-book-sign-in-form-container'),
      signInLink = this.signInContainer.find('#appt-book-sign-in-link').off('click'),
      loginEmail = this.signInContainer.find('#appt-book-login-email'),
      pw = this.signInContainer.find('#appt-book-login-password'),
      signInBtn = signIn.find('#appt-book-login-submit').off('click'),
      bookBtn = this.confContainer.find('#appt-book-book-submit').off('click'),
      fbsignInBtn = signIn.find('#appt-book-fblogin-submit').off('click'),
      fNameInput = this.bookContainer.find('.appt-book-first-name'),
      lNameInput = this.bookContainer.find('.appt-book-last-name'),
      emailInput = this.bookContainer.find('.appt-book-email'),
      phoneInput = this.bookContainer.find('.appt-book-mobile'),
      phoneInputPrefix = this.bookContainer.find('.appt-book-mobile-prefix'),
      cpfInput = this.bookContainer.find('.appt-book-cpf-field'),
      apptBookingHelpers = this.bookContainer.find('.appt_booking_helpers'),
      apptUseKRMobileNumberFields = apptBookingHelpers.data('apptUseKrMobileNumberFields') || 0,
      commentsInput = this.bookContainer.find('.appt-book-note'),
      signUpEmailInput = this.bookContainer.find('.registration__email-list').find('input'),
      signUpSMSInput = this.bookContainer.find('.registration__sms-list').find('input'),
      signUpApptSMSNotificationsEnabledInput = this.bookContainer.find('.enable_sms_notifications'),
      isSMSNotificationsEnabled = this.bookContainer.data('enableSms'),
      smsNotificationTerms = this.bookContainer.find('input[name=APPT_SMS_NOTIFICATIONS]'),
      errorContainer = this.container.find('#appt-book-confirm-error-messages'),
      errorMessages = errorContainer.find('.error-message'),
      termsCheckbox = this.bookContainer.find('.appt-book-terms'),
      termsCommercialCheckbox = this.bookContainer.find('.appt-book-terms-commercial'),
      termsCheckboxLabel = this.bookContainer.find('.registration__terms'),
      termsCommercialCheckboxLabel = this.bookContainer.find('.registration__terms_commercial'),
      termsPrivacyRadio = this.bookContainer.find('.appt-book-oab-legal-privacy'),
      termsEmailPromotionsRadio = this.bookContainer.find('.appt-book-oab-email-promotions'),
      termsSMSPromotionsRadio = this.bookContainer.find('.appt-book-oab-sms-notification'),
      termsPostalRadio = this.bookContainer.find('.appt-book-oab-postal'),
      termsPrivacyRadioLabel = this.bookContainer.find('.accept-terms-head'),
      termsSMSNotificationRadioLabel = this.bookContainer.find('.accept-sms-notification-head'),
      termsEmailPromotionsRadioLabel = this.bookContainer.find('.accept-email-head'),
      termsSMSPromotionsRadioLabel = this.bookContainer.find('.accept-sms-head'),
      termsPostalRadioLabel = this.bookContainer.find('.accept-postal-head'),
      acceptCommercialChkbox = this.bookContainer.find('input[name=ACCEPTED_COMMERCIAL]'),
      acceptCommercialChkboxLabel = this.bookContainer.find('.registration__commercial-list'),
      signUpEmailInputLabel = this.bookContainer.find('.registration__email-list'),
      countryCode = apptBookingHelpers.data('countryCode'),
      countryCodeFieldset = this.bookContainer.find('.mobile-phone-fieldset'),
      countryCodes = countryCodeFieldset.data('apptPhoneCodes'),
      countryCodeSelect = this.bookContainer.find('.js_appt_phone_code'),
      codeCountry =
        countryCodeFieldset.attr('data-country-code') || phoneInput.attr('data-country-code'),
      signInHeight,
      fsite = site || {},
      drupal = Drupal || {},
      settings = drupal.settings || {},
      phone1Input,
      phone2Input,
      apptKrSelectPhoneCode,
      apptKRPhoneCode,
      populateKRPhoneField,
      populateMobilePhoneWithPrefix,
      mobileParts;
    var apptPhoneCodeSplit, codeOptions;

    if (apptUseKRMobileNumberFields) {
      phone1Input = this.bookContainer.find('.js_appt_mobile_part1');
      phone2Input = this.bookContainer.find('.js_appt_mobile_part2');
      apptKRPhoneCode = this.bookContainer.find('.js_appt_kr_phone_code');
      var apptPhoneCode = apptBookingHelpers.data('apptPhoneCodes');

      apptKrSelectPhoneCode = this.bookContainer.find('select.js_appt_kr_phone_code');
      apptPhoneCodeSplit = apptPhoneCode.split(',');
      if (apptKRPhoneCode.find('option').length === 1) {
        $.each(apptPhoneCodeSplit, function (i, val) {
          codeOptions = $('<option></option>', {
            value: val,
            text: val
          });
          apptKRPhoneCode.append(codeOptions);
        });
      }
      phoneInput.keydown(function (e) {
        var key = e.charCode || e.keyCode || 0;

        return (
          key === 8 ||
          key === 9 ||
          key === 46 ||
          (key >= 48 && key <= 57) ||
          (key >= 96 && key <= 105)
        );
      });
    } else if (countryCodes) {
      apptPhoneCodeSplit = countryCodes.split(',');
      if (countryCodeSelect.find('option').length === 1) {
        $.each(apptPhoneCodeSplit, function (i, val) {
          codeOptions = $('<option></option>', {
            value: val,
            text: val
          });
          countryCodeSelect.append(codeOptions);
        });
      }
    }

    populateKRPhoneField = function (mobilePhone) {
      mobileParts = (/^(\d{3})-?(\d{4})-?(\d*)$/gu).exec(mobilePhone);
      if (mobileParts && mobileParts[1] && mobileParts[2] && mobileParts[3]) {
        apptKRPhoneCode.val(mobileParts[1]);
        phone1Input.val(mobileParts[2]);
        phone2Input.val(mobileParts[3]);
      }
    };

    populateMobilePhoneWithPrefix = function (mobilePhone) {
      mobileParts = (/^(\d+)-(\d*)$/gu).exec(mobilePhone);
      if (mobileParts && mobileParts[1] && mobileParts[2]) {
        countryCodeSelect.val('+' + mobileParts[1]);
        phoneInput.val(mobileParts[2]);
      }
    };

    if (settings.fb_login_app_id && fsite.facebook) {
      site.facebook.init();
      if (!site.client.isMobile) {
        signInHeight = 390; // pc
      } else {
        signInHeight = 520; // mobile
      }
    }

    this.startOver.off('click');
    this.startOver.on('click', function () {});

    fNameInput.placeholder();
    fNameInput.value = fNameInput.attr('placeholder');
    fNameInput.addClass('appt-placeholder');

    lNameInput.placeholder();
    lNameInput.value = lNameInput.attr('placeholder');
    lNameInput.addClass('appt-placeholder');

    emailInput.placeholder();
    emailInput.value = emailInput.attr('placeholder');
    emailInput.addClass('appt-placeholder');

    phoneInput.placeholder();
    phoneInput.value = phoneInput.attr('placeholder');
    phoneInput.addClass('appt-placeholder');
    if (require_cpf) {
      cpfInput.placeholder();
      cpfInput.value = cpfInput.attr('placeholder');
      cpfInput.addClass('appt-placeholder');
    }
    commentsInput.keyup(function (e) {
      var maxlength = commentsInput.attr('maxlength');

      if (!!maxlength) {
        var text = commentsInput.val();

        if (text.length > maxlength) {
          commentsInput.val(text.substring(0, maxlength));
          e.preventDefault();
        }
      }
    });

    phoneInput.keydown(function (e) {
      var key = e.charCode || e.keyCode || 0;

      // Allow numeric (and tab, backspace, delete) keys only
      return (
        key === 8 ||
        key === 9 ||
        key === 46 ||
        (key >= 48 && key <= 57) ||
        (key >= 96 && key <= 105)
      );
    });

    phoneInput.keyup(function (e) {
      var $this = $(this);
      var maxlength = $this.attr('data-placeholder-maxlength');

      if (!!maxlength) {
        var text = $this.val();

        if (text.length > maxlength) {
          $this.val(text.substring(0, maxlength));
          e.preventDefault();
        }
      }
    });

    loginEmail.val('');
    pw.val('');
    emailInput.val('').removeAttr('disabled');
    commentsInput.val('');
    this.totalElem.empty();

    if (this.userData && this.userData.signed_in) {
      this.signInContainer.css('display', 'none');

      if (this.userData.first_name) {
        fNameInput.val(this.userData.first_name);
      }

      if (this.userData.last_name) {
        lNameInput.val(this.userData.last_name);
      }

      emailInput.val(this.userData.email_address).attr('disabled', 'disabled');

      if (this.userData.mobile_phone) {
        if (apptUseKRMobileNumberFields) {
          populateKRPhoneField(this.userData.mobile_phone);
        } else if (countryCodes) {
          populateMobilePhoneWithPrefix(this.userData.mobile_phone);
        } else {
          phoneInput.val(this.userData.mobile_phone);
        }
      }

      if (site.client.isMobile) {
        if (this.userData.mobile_email_optin || this.userData.pc_email_optin) {
          signUpEmailInput.attr('checked', 'checked');
        } else {
          signUpEmailInput.removeAttr('checked');
        }
      } else {
        if (this.userData.pc_email_optin) {
          signUpEmailInput.attr('checked', 'checked');
        } else {
          signUpEmailInput.removeAttr('checked');
        }
      }

      if (this.userData.sms_optin) {
        signUpSMSInput.attr('checked', 'checked');
      } else {
        signUpSMSInput.removeAttr('checked');
      }
    } else {
      this.signInContainer.css('display', 'block');
    }

    totText = this.totalText + ' ' + this.totalTime + ' ' + this.minLabel;
    if (this.totalCost && allow_priced_services) {
      totText +=
        ' / ' +
        (OAB_price_override
          ? this.totalCost + '\xA0' + currencySymbol
          : currencySymbol + this.totalCost);
      this.totalElem.addClass('priced');
      this.confContainer.find('.appt-book-book-submit').addClass('priced');
    } else {
      this.totalElem.removeClass('priced');
      this.confContainer.find('.appt-book-book-submit').removeClass('priced');
    }
    this.totalElem.html(totText);

    this.calModel.on('time_selected', function (data) {
      bookBtn.removeClass('disabled');
    });

    this.calModel.on('time_deselected', function (data) {
      bookBtn.addClass('disabled');
    });

    signInLink.on('click', function (e) {
      e.preventDefault();
      var h;

      $(this).css('display', 'none');
      signIn.css('display', 'block');
      h = signInHeight || signIn.css('height');
      signInHeight = h;
      signIn.height(0);
      signIn.animate({ height: h }, 1000, function () {
        setSignIn();
      });
    });

    window.fbsignInBtn = fbsignInBtn;

    function setSignIn() {
      fbsignInBtn.on('click', function (e) {
        var token = null,
          $this = $(this),
          params = [],
          last_source = null,
          pc_email_promotions = 0,
          $optInFormInput = $('#form--facebook_signin--field--PC_EMAIL_PROMOTIONS');

        if ($this.hasClass('disabled')) {
          return;
        }
        last_source = 'appointment_booking';
        pc_email_promotions = $optInFormInput.is(':checked') ? 1 : 0;

        FB.getLoginStatus(function (response) {
          statusChangeCallback(response);
        });

        function statusChangeCallback(response) {
          if (FB.getAuthResponse()) {
            token = response.authResponse.accessToken;
            rpccall();
          }
        }

        function rpccall() {
          $this.addClass('disabled');
          params.push({
            _SUBMIT: 'facebook_signin',
            token: token,
            LAST_SOURCE: last_source,
            PC_EMAIL_PROMOTIONS: pc_email_promotions
          });

          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: JSON.stringify(params),
            onSuccess: function (jsonRpcResponse) {
              var h,
                rData = jsonRpcResponse.getData().userinfo;

              me.model.updateAuthToken(function () {
                $this.removeClass('disabled');
                emailInput.val(rData.email_address).attr('disabled', 'disabled');

                if (rData.first_name) {
                  fNameInput.val(rData.first_name);
                }
                if (rData.last_name) {
                  lNameInput.val(rData.last_name);
                }
                if (rData.mobile_number) {
                  phoneInput.val(rData.mobile_number);
                }

                if (rData.mobile_phone) {
                  if (apptUseKRMobileNumberFields) {
                    populateKRPhoneField(rData.mobile_phone);
                  } else if (countryCodes) {
                    populateMobilePhoneWithPrefix(rData.mobile_phone);
                  } else {
                    phoneInput.val(rData.mobile_phone);
                  }
                }

                if (site.client.isMobile) {
                  if (rData.mobile_email_optin) {
                    signUpEmailInput.attr('checked', 'checked');
                  } else {
                    signUpEmailInput.removeAttr('checked');
                  }
                } else {
                  if (rData.pc_email_optin) {
                    signUpEmailInput.attr('checked', 'checked');
                  } else {
                    signUpEmailInput.removeAttr('checked');
                  }
                }

                if (rData.sms_optin) {
                  signUpSMSInput.attr('checked', 'checked');
                } else {
                  signUpSMSInput.removeAttr('checked');
                }

                fNameInput.focus();

                me.userData = rData;
              });

              errorContainer.css('display', 'none');
              errorMessages.css('display', 'none');
              pw.removeClass('error');
              loginEmail.removeClass('error');

              $this.removeClass('disabled');

              signInLink.css('display', 'inline-block');

              h = signIn.css('height');
              signIn.animate({ height: 0 }, 1000, function () {
                signIn.css('display', 'none');
                signIn.height(h);
                me.signInContainer.css('display', 'none');
              });
            },
            onFailure: function (jsonRpcResponse) {
              var errObjs = jsonRpcResponse.getMessages();

              errorContainer.css('display', 'block');
              errorMessages.css('display', 'none');
              pw.removeClass('error');
              me.bookContainer.addClass('guest');
              loginEmail.removeClass('error');

              for (var i = 0; i < errObjs.length; i += 1) {
                var myErr = errObjs[i];

                if (myErr && myErr.key) {
                  if (
                    myErr.key === 'required.password.signin' ||
                    myErr.key === 'required.password.signin.app'
                  ) {
                    pw.addClass('error');
                    errorMessages.filter('#error-signin-password').css('display', 'block');
                  }

                  if (
                    myErr.key === 'invalid.password.signin' ||
                    myErr.key === 'invalid.password.signin.app'
                  ) {
                    pw.addClass('error');
                    errorMessages.filter('#error-signin-invalid-password').css('display', 'block');
                  }

                  if (
                    myErr.key === 'required_or.device_id.login_id.required_or.signin' ||
                    myErr.key === 'required_or.email_address.device_id.required_or.signin' ||
                    myErr.key === 'required_or.email_address.device_id.required_or.signin.app'
                  ) {
                    loginEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }

                  if (
                    myErr.key === 'required.email_address.signin' ||
                    myErr.key === 'required.email_address.signin.app'
                  ) {
                    loginEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }

                  if (
                    myErr.key === 'invalid.email_address.signin' ||
                    myErr.key === 'invalid.email_address.signin.app'
                  ) {
                    loginEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }

                  if (
                    myErr.key === 'no_account..signin' ||
                    myErr.key === 'no_account..signin.app'
                  ) {
                    loginEmail.addClass('error');
                    pw.addClass('error');
                    errorMessages.filter('#error-signin-no-account').css('display', 'block');
                  }

                  if (myErr.key === 'account_lockout' || myErr.key === 'account_lockout.app') {
                    errorMessages.filter('#error-signin-account-lockout').css('display', 'block');
                  }

                  if (
                    myErr.key === 'social_fb_no_email' ||
                    myErr.key === 'social_fb_no_email.app'
                  ) {
                    errorMessages.filter('#error-others').css('display', 'block').text(myErr.text);
                  }

                  if (
                    myErr.key === 'social_duplicate_account_links' ||
                    myErr.key === 'social_duplicate_account_links.app'
                  ) {
                    errorMessages.filter('#error-others').css('display', 'block').text(myErr.text);
                  }

                  if (myErr.key === 'signin_error2' || myErr.key === 'signin_error2.app') {
                    errorMessages.filter('#error-others').css('display', 'block').text(myErr.text);
                  }
                }
              }
              $this.removeClass('disabled');
            }
          });
        }
      });

      signInBtn.on('click', function (e) {
        e.preventDefault();
        var $this = $(this),
          params = [];

        if ($this.hasClass('disabled')) {
          return;
        }

        $this.addClass('disabled');
        params.push({
          _SUBMIT: 'signin',
          EMAIL_ADDRESS: loginEmail.val(),
          PASSWORD: pw.val()
        });

        if ($.cookie('csrftoken')) {
          params[0]['_TOKEN'] = $.cookie('csrftoken');
        }

        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: JSON.stringify(params),
          onSuccess: function (jsonRpcResponse) {
            var h,
              rData = jsonRpcResponse.getData().userinfo;

            me.model.updateAuthToken(function () {
              $this.removeClass('disabled');
              emailInput.val(rData.email_address).attr('disabled', 'disabled');

              if (rData.first_name) {
                fNameInput.val(rData.first_name);
              }
              if (rData.last_name) {
                lNameInput.val(rData.last_name);
              }
              if (rData.mobile_number) {
                phoneInput.val(rData.mobile_number);
              }

              if (rData.mobile_phone) {
                if (apptUseKRMobileNumberFields) {
                  populateKRPhoneField(rData.mobile_phone);
                } else if (countryCodes) {
                  populateMobilePhoneWithPrefix(rData.mobile_phone);
                } else {
                  phoneInput.val(rData.mobile_phone);
                }
              }

              if (site.client.isMobile) {
                if (rData.mobile_email_optin) {
                  signUpEmailInput.attr('checked', 'checked');
                } else {
                  signUpEmailInput.removeAttr('checked');
                }
              } else {
                if (rData.pc_email_optin) {
                  signUpEmailInput.attr('checked', 'checked');
                } else {
                  signUpEmailInput.removeAttr('checked');
                }
              }

              if (rData.sms_optin) {
                signUpSMSInput.attr('checked', 'checked');
              } else {
                signUpSMSInput.removeAttr('checked');
              }

              fNameInput.focus();

              me.userData = rData;
            });

            errorContainer.css('display', 'none');
            errorMessages.css('display', 'none');
            pw.removeClass('error');
            loginEmail.removeClass('error');

            $this.removeClass('disabled');

            signInLink.css('display', 'inline-block');

            h = signIn.css('height');
            signIn.animate({ height: 0 }, 1000, function () {
              signIn.css('display', 'none');
              signIn.height(h);
              me.signInContainer.css('display', 'none');
            });
          },
          onFailure: function (jsonRpcResponse) {
            var errObjs = jsonRpcResponse.getMessages();

            errorContainer.css('display', 'block');
            errorMessages.css('display', 'none');
            pw.removeClass('error');
            loginEmail.removeClass('error');

            for (var i = 0; i < errObjs.length; i += 1) {
              var myErr = errObjs[i];

              if (myErr && myErr.key) {
                if (
                  myErr.key === 'required.password.signin' ||
                  myErr.key === 'min_max.password.signin'
                ) {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-password').css('display', 'block');
                }

                if (myErr.key === 'invalid.password.signin') {
                  pw.addClass('error');
                  errorMessages.filter('#invalid-signin-password').css('display', 'block');
                }

                if (
                  myErr.key === 'required.email_address.signin' ||
                  myErr.key === 'required_or.email_address.device_id.required_or.signin'
                ) {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'invalid.email_address.signin') {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'no_account..signin') {
                  loginEmail.addClass('error');
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-no-account').css('display', 'block');
                }

                if (myErr.key === 'format.password.signin') {
                  loginEmail.addClass('error');
                  pw.addClass('error');
                  errorMessages.filter('#invalid-password-format').text(myErr.text);
                  errorMessages.filter('#invalid-password-format').css('display', 'block');
                }
              }
            }

            $this.removeClass('disabled');
          }
        });
      });
    }

    bookBtn.click(onSubmitBooking);

    function onSubmitBooking(e) {
      e.preventDefault();
      var params = {},
        signUpEmailParams = [],
        signUpEmailObj = {},
        fName = fNameInput.val(),
        lName = lNameInput.val(),
        email = emailInput.val(),
        phone = countryCodeSelect.length
          ? countryCodeSelect.val() + phoneInput.val()
          : phoneInput.val(),
        cpf = cpfInput.val() ? cpfInput.val() : 0,
        terms = termsCheckbox.is(':checked') ? 1 : 0,
        commercialTerms = termsCommercialCheckbox.is(':checked') ? 1 : 0,
        signUpEmail = signUpEmailInput.is(':checked') ? signUpEmailInput.val() : 0,
        signUpSMS = signUpSMSInput.is(':checked') ? signUpSMSInput.val() : 0,
        enableApptSMS = isSMSNotificationsEnabled,
        requireTermsForSMS = smsNotificationTerms.length ? 1 : 0,
        oabTermsEmailPromotionsRadio = termsEmailPromotionsRadio.is(':checked')
          ? $('input[name=PC_EMAIL_PROMOTIONS]:checked').val()
          : 0,
        oabTermsSMSPromotionsRadio = termsSMSPromotionsRadio.is(':checked')
          ? $('input[name=SMS_PROMOTIONS]:checked').val()
          : 0,
        oabTermsPostalRadio = termsPostalRadio.is(':checked')
          ? $('input[name=POSTAL_PROMOTIONS]:checked').val()
          : 0,
        signUpEmailDone = false,
        signUpSMSDone = false,
        comments = commentsInput.val(),
        $this = $(this),
        isEmptyField = 0,
        isArray = me.serviceIds instanceof Array,
        phone_full_length,
        phone_zero_length_regex,
        oabSMSNotificationTermsAccepted;

      if (requireTermsForSMS) {
        if (smsNotificationTerms.attr('type') === 'checkbox') {
          oabSMSNotificationTermsAccepted = smsNotificationTerms.is(':checked') ? 1 : 0;
        } else {
          oabSMSNotificationTermsAccepted = signUpApptSMSNotificationsEnabledInput.is(':checked')
            ? signUpApptSMSNotificationsEnabledInput.closest(':checked').val()
            : 0;
        }
      }

      if ($this.hasClass('disabled')) {
        return;
      }

      errorContainer.css('display', 'block');
      errorMessages.css('display', 'none');
      me.container.find('input, textarea, .label, label, .picker-handle').removeClass('error');
      emptyInputs();
      if (isEmptyField) {
        $this.removeClass('disabled');

        return;
      }
      $this.addClass('disabled');

      params = {
        counter_id: me.counterId,
        calendar_id: me.calendarId,
        appointment_service_id: me.serviceIds,
        start_time: me.calModel.getSelection().selectionString,
        customer_first_name: fName,
        customer_last_name: lName,
        customer_email: email
      };
      site?.track?.evtLink && site.track.evtLink({
        event_name: 'appointmentBooking_DateTime',
        event_category: 'appointment booking',
        event_action: 'Date and Time Picked',
        event_label:
          me.counterData.store_no + ' - ' + me.counterData.name + ' - ' + params.start_time
      });
      site?.track?.evtLink && site.track.evtLink({
        event_name: 'appointmentBooking_bookNow',
        event_category: 'appointment booking',
        event_action: 'bookNow',
        event_label:
          me.counterData.store_no + ' - ' + me.counterData.name + ' - ' + params.start_time
      });

      if (comments) {
        params.customer_comments = comments;
      }

      if (phone) {
        if (apptUseKRMobileNumberFields) {
          var area_code = apptKrSelectPhoneCode.val();

          if (area_code) {
            area_code = area_code.substr(1, 2);
          }
          params.customer_phone = countryCode + area_code + phone1Input.val() + phone2Input.val();
        } else {
          // making sure we pass phone number stripped from any dashes, brackets and leading zeros
          params.customer_phone = phone.replace(/\(|\)|-/gi, '');
          params.customer_phone = params.customer_phone.replace(/^(0)(\d+)$/, '$2');
          if (oab_use_countrycode) {
            params.customer_phone = codeCountry + params.customer_phone;
          } else {
            params.customer_phone = phoneInputPrefix.length
              ? phoneInputPrefix.val().replace('(0)', '').replace('+', '00') + params.customer_phone
              : '' + phone.replace('+', '00');
          }
        }
      }

      if (require_cpf) {
        params.cpf = cpf;
      }

      if (enableApptSMS) {
        if (requireTermsForSMS) {
          if (oabSMSNotificationTermsAccepted) {
            params.sms_notifications_enabled = oabSMSNotificationTermsAccepted;
          }
        } else {
          params.sms_notifications_enabled = enableApptSMS;
        }
      }

      function emptyInputs() {
        var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
        var phone_maxlength = phoneInput.attr('maxlength');
        var phone_regex = new RegExp(phoneInput.attr('pattern'));
        var phone1_regex, phone2_regex;

        if (apptUseKRMobileNumberFields) {
          phone1_regex = new RegExp(phone1Input.attr('pattern'));
          phone2_regex = new RegExp(phone2Input.attr('pattern'));
          phone_full_length = phone1Input.val() + phone2Input.val();
          phone_zero_length_regex = /^(?!0+$)\d{7,8}$/;
        }

        if (!fNameInput.val()) {
          errorMessages.filter('#error-book-first-name').css('display', 'block');
          fNameInput.addClass('error');
          isEmptyField = 1;
        }
        // Don't validate last name if we have hidden that element
        if (!$(lNameInput.parent()).hasClass('no-last-name') && !lNameInput.val()) {
          errorMessages.filter('#error-book-last-name').css('display', 'block');
          lNameInput.addClass('error');
          isEmptyField = 1;
        }
        if (!emailInput.val() || !testEmail.test(emailInput.val())) {
          errorMessages.filter('#error-book-email').css('display', 'block');
          emailInput.addClass('error');
          isEmptyField = 1;
        }
        if (termsCheckbox.val() && !termsCheckbox.is(':checked')) {
          errorMessages.filter('#error-terms').css('display', 'block');
          termsCheckboxLabel.addClass('error');
          isEmptyField = 1;
        }
        if (termsCommercialCheckbox.val() && !termsCommercialCheckbox.is(':checked')) {
          errorMessages.filter('#error-terms-commercial').css('display', 'block');
          termsCommercialCheckboxLabel.addClass('error');
          isEmptyField = 1;
        }
        if (apptUseKRMobileNumberFields) {
          if (phone_full_length && !phone_zero_length_regex.test(phone_full_length)) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
          if (!apptKrSelectPhoneCode.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          } else {
            apptKRPhoneCode.removeClass('error');
          }
          if (phone1Input.val()) {
            if (phone1_regex && !phone1_regex.test(phone1Input.val())) {
              errorMessages.filter('#error-book-mobile').css('display', 'block');
              errorMessages.filter('#error-book-mobile_part1_invalid').css('display', 'block');
              apptKRPhoneCode.addClass('error');
              phone1Input.addClass('error');
              phone2Input.addClass('error');
              isEmptyField = 1;
            }
          } else if (!phone1Input.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
          if (phone2Input.val()) {
            if (phone2_regex && !phone2_regex.test(phone2Input.val())) {
              errorMessages.filter('#error-book-mobile').css('display', 'block');
              errorMessages.filter('#error-book-mobile_part2_invalid').css('display', 'block');
              apptKRPhoneCode.addClass('error');
              phone1Input.addClass('error');
              phone2Input.addClass('error');
              isEmptyField = 1;
            }
          } else if (!phone2Input.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
        } else {
          if (!phoneInput.val() && errorMessages.filter('#error-signup-sms').is(':hidden')) {
            errorMessages.filter('#error-book-phone').css('display', 'block');
            phoneInput.addClass('error');
            isEmptyField = 1;
          } else if (phone.length > phone_maxlength || !phone_regex.test(phone)) {
            phoneInput.addClass('error');
            errorContainer.css('display', 'block');
            errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
            isEmptyField = 1;
          }
          if (countryCodeSelect.length && countryCodeSelect.val() === '') {
            countryCodeSelect.addClass('error');
            isEmptyField = 1;
          }
          if (commercial_agreement) {
            if (signUpEmailInput.is(':checked') && !acceptCommercialChkbox.is(':checked')) {
              errorMessages.filter('#error-commercial-terms').css('display', 'block');
              acceptCommercialChkboxLabel.addClass('error');
              isEmptyField = 1;
            }
            if (!signUpEmailInput.is(':checked') && acceptCommercialChkbox.is(':checked')) {
              errorMessages.filter('#error-commercial-terms').css('display', 'block');
              signUpEmailInputLabel.addClass('error');
              isEmptyField = 1;
            }
          }
        }
        if (oab_legal_statement_promotions) {
          if (!termsPrivacyRadio.is(':checked')) {
            errorMessages.filter('#error-oab-accept-privacy-policy').css('display', 'block');
            termsPrivacyRadioLabel.addClass('error');
            isEmptyField = 1;
          } else if (
            termsPrivacyRadio.is(':checked') &&
            $('input[name=ACCEPTED_PRIVACY_POLICY]:checked').val() === '0'
          ) {
            errorMessages.filter('#error-oab-accept-privacy-policy').css('display', 'block');
            termsPrivacyRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsPrivacyRadioLabel.removeClass('error');
          }
          if (
            signUpApptSMSNotificationsEnabledInput.length &&
            !signUpApptSMSNotificationsEnabledInput.is(':checked')
          ) {
            errorMessages.filter('#error-oab-sms-notification').css('display', 'block');
            termsSMSNotificationRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsSMSNotificationRadioLabel.removeClass('error');
          }
          if (!termsEmailPromotionsRadio.is(':checked')) {
            errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
            termsEmailPromotionsRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsEmailPromotionsRadioLabel.removeClass('error');
          }
          if (!termsSMSPromotionsRadio.is(':checked')) {
            errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
            termsSMSPromotionsRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsSMSPromotionsRadioLabel.removeClass('error');
          }
          if (!termsPostalRadio.is(':checked')) {
            errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
            termsPostalRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsPostalRadioLabel.removeClass('error');
          }
        }

        if (require_cpf && cpf !== 0) {
          var cpf_regex = new RegExp(cpfInput.attr('pattern'));
          if (!cpf_regex.test(cpf) || !validateCpf(cpf)) {
            errorMessages.filter('#error-book-cpf').css('display', 'block');
            cpfInput.addClass('error');
            isEmptyField = 1;
          }
        }
      }

      function onBookSuccess(r) {
        var updateData,
          apptId = r.id;

        site?.track?.evtView && site.track.evtView({
          page_url: '/book-appointment/complete',
          location: location.origin + '/book-appointment/complete',
          page_name: 'Book Appointment - Complete'
        });
        site?.track?.evtLink && site.track.evtLink({
          event_name: 'appointmentBooking_complete',
          event_category: 'appointment booking',
          event_action: 'appointment booked',
          event_label: r.counter.store_no + ' - ' + r.counter.name + ' - ' + r.start_time
        });
        updateData = {
          sectionId: 'next',
          params: r
        };
        me.model.update(updateData);
        $this.addClass('disabled');
        errorMessages.css('display', 'none');
        errorContainer.css('display', 'none');
        me.container.find('input').removeClass('error');
        me.container.find('textarea').removeClass('error');
      }

      function onBookError(r) {
        $this.removeClass('disabled');

        var errFName = r.customer_first_name,
          errLName = r.customer_last_name,
          errEmail = r.customer_email,
          errPhone = r.customer_phone,
          errComments = r.customer_comments,
          errorCode = r.code;

        errorContainer.css('display', 'block');
        errorMessages.css('display', 'none');
        var errorShown = false;

        if (errFName && errFName.length) {
          errorMessages.filter('#error-book-first-name').css('display', 'block');
          fNameInput.addClass('error');
          errorShown = true;
        }
        if (errLName && errLName.length) {
          errorMessages.filter('#error-book-last-name').css('display', 'block');
          lNameInput.addClass('error');
          errorShown = true;
        }
        if (errEmail && errEmail.length) {
          errorMessages.filter('#error-book-email').css('display', 'block');
          emailInput.addClass('error');
          errorShown = true;
        }
        if (errPhone && errPhone.length) {
          errorMessages.filter('#error-book-phone').css('display', 'block');
          phoneInput.addClass('error');
          errorShown = true;
        }
        if (errComments && errComments.length) {
          errorMessages.filter('#error-book-comments').css('display', 'block');
          commentsInput.addClass('error');
          errorShown = true;
        }

        // Unhandled error should still show the user something
        if (!errorShown) {
          me.launchBookConflictOverlay();
        }
      }

      function doBooking() {
        $this.removeClass('disabled');
        errorMessages.css('display', 'none');
        me.container
          .find('input, textarea, .label, label, .picker-handle', 'select')
          .removeClass('error');

        emptyInputs();

        var phone_maxlength = phoneInput.attr('maxlength');
        var phone_regex = new RegExp(phoneInput.attr('pattern'));

        if (require_cpf) {
          var cpf_regex = new RegExp(cpfInput.attr('pattern'));

          if (!cpf_regex.test(cpf) || !validateCpf(cpf)) {
            errorMessages.filter('#error-book-cpf').css('display', 'block');
            cpfInput.addClass('error');
          }
        }
        if (!phoneInput.val() && errorMessages.filter('#error-signup-sms').is(':hidden')) {
          errorMessages.filter('#error-book-phone').css('display', 'block');
          phoneInput.addClass('error');
        } else if (phone.length > phone_maxlength || !phone_regex.test(phone)) {
          phoneInput.addClass('error');
          errorContainer.css('display', 'block');
          errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
        } else if (me.updateMode && me.appointmentId) {
          me.model.changeAppointment(me.appointmentId, params, onBookSuccess, onBookError);
        } else {
          me.model.bookAppointment(params, onBookSuccess, onBookError);
        }
      }

      signUpEmailObj._SUBMIT = 'email_signup';
      signUpEmailObj.EMAIL_ADDRESS = email;
      signUpEmailObj.PC_EMAIL_ADDRESS = email;
      signUpEmailObj.LAST_SOURCE = 'appointment_booking_reg';

      if (!signUpEmail) {
        if (!oab_legal_statement_promotions && me.userData.recognized_user) {
          signUpEmailObj.ACTION = 'unset';
        } else {
          signUpEmailObj.ACTION = '';
        }
      }
      if (oab_legal_statement_promotions) {
        signUpEmailObj.LAST_SOURCE = 'appointment_booking';
        signUpEmailObj.ORIGINAL_SOURCE = 'appointment_booking';
        signUpEmailObj.suppress_conf_email = 1;
        signUpEmailObj.ACCEPTED_PRIVACY_POLICY = 1;
        signUpEmailObj.ACTION = 'unset';
        signUpEmailObj.PC_EMAIL_PROMOTIONS = '0';
        signUpEmailObj.SMS_PROMOTIONS = '0';
        signUpEmailObj.POSTAL_PROMOTIONS = '0';
        signUpEmailObj.ACCEPTED_THIRD_PARTY = '0';
      }
      if (do_not_submit_sms_pg_form) {
        if (signUpSMS && (!me.userData || !me.userData.sms_optin)) {
          signUpEmailObj._SECONDARY_SUBMIT = 'sms';
          signUpEmailObj.MOBILE_PHONE = phone;
          signUpEmailObj.MOBILE_NUMBER = phone;
          signUpEmailObj.SMS_PROMOTIONS = 1;
        }

        if (!signUpSMS) {
          signUpEmailObj._SECONDARY_SUBMIT = 'sms';
          signUpEmailObj.SMS_PROMOTIONS = 0;
        }
      }

      var settings = Drupal.settings.globals_variables || {};
      var oab_params =
        settings.appointment_booking_terms !== 'undefined' ? settings.appointment_booking_terms : 0;

      if (oab_params) {
        signUpEmailObj.PC_EMAIL_PROMOTIONS = signUpEmail;
        signUpEmailObj.ACCEPTED_PRIVACY_POLICY = terms;
        if (commercialTerms) {
          signUpEmailObj.DATA_PRIVACY_CONSENT = terms;
          signUpEmailObj.COMMERCIAL_PERMISSION = commercialTerms;
          signUpEmailObj.MOBILE_NUMBER = phone;
        }
      }
      if (commercial_agreement && signUpEmail) {
        signUpEmailObj.ACCEPTED_COMMERCIAL = 1;
      }
      signUpEmailParams.push(signUpEmailObj);

      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: JSON.stringify(signUpEmailParams),
        onSuccess: function (jsonRpcResponse) {
          signUpEmailDone = true;
          doBooking();
        },
        onFailure: function (jsonRpcResponse) {
          var errObjs = jsonRpcResponse.getMessages();

          errorContainer.css('display', 'block');
          errorMessages.css('display', 'none');

          for (var i = 0; i < errObjs.length; i += 1) {
            var myErr = errObjs[i];

            if (myErr && myErr.key) {
              if (
                myErr.key === 'required.pc_email_address.email_signup' ||
                myErr.key === 'invalid.pc_email_address.email_signup'
              ) {
                emailInput.addClass('error');
                errorMessages.filter('#error-signup-email').css('display', 'block');
              }

              if (myErr.key === 'required_dependency.sms_promotions.mobile_phone.dependency.sms') {
                phoneInput.addClass('error');
                errorMessages.filter('#error-signup-sms').css('display', 'block');
              }

              if (myErr.key === 'invalid.mobile_phone.sms') {
                phoneInput.addClass('error');
                errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
              }
            }
          }

          emptyInputs();

          var phone_maxlength = phoneInput.attr('maxlength');
          var phone_regex = new RegExp(phoneInput.attr('pattern'));

          if (!phoneInput.val() && errorMessages.filter('#error-signup-sms').is(':hidden')) {
            errorMessages.filter('#error-book-phone').css('display', 'block');
            phoneInput.addClass('error');
          } else if (phone.length > phone_maxlength || !phone_regex.test(phone)) {
            phoneInput.addClass('error');
            errorContainer.css('display', 'block');
            errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
          }

          $this.removeClass('disabled');
        }
      });
    }
  };

  apptBook.AppointmentSelectSection.prototype.launchSelErrOverlay = function () {
    var me = this;

    this.jqBod.prepend(this.selErrOverlay);
    this.selErrOverlay.show();
    this.selErrOverlay.off('click');
    this.selErrOverlay.on('click', function (e) {
      e.preventDefault();
      var upObj = {
        sectionId: 'previous',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          updateMode: me.updateMode
        }
      };

      me.model.update(upObj);
      me.selErrOverlay.off('click');
      me.selErrOverlay.remove();
    });
  };

  apptBook.AppointmentSelectSection.prototype.launchBookConflictOverlay = function () {
    var me = this,
      selDate = this.calModel.getSelection().selectionDate;

    this.jqBod.prepend(this.bookConflictOverlay);
    this.calModel.update({ date: selDate });
    this.bookConflictOverlay.show();
    this.bookConflictOverlay.on('click', function (e) {
      e.preventDefault();
      me.bookConflictOverlay.off('click');
      me.bookConflictOverlay.remove();
    });
  };

  /* *
   *
   * Appointments Time Slot Selector Calendar and Mobile Calendar
   * This is a set of Classes that create objects that are the members of an MVC Calendar that displays and allows
   * selection of the available time slots of calendars coming from the API.
   *
   *
   *
   * */

  /**
   * CalendarModel
   * This is the model. It controls the calendars state and main logic.
   * It broadcasts updates to registered views and controllers
   *
   */

  apptBook.CalendarModel = function () {
    apptBook.CalendarModel.superclass.constructor.call(this);
    this.dataSet = false;
  };

  // CalendarModel is a Publisher in a Publisher Subscriber (event listening) pattern.
  ctrlopt.extend(apptBook.CalendarModel, ctrlopt.Publisher);

  apptBook.CalendarModel.prototype.setData = function (options) {
    if (this.dataSet) {
      return;
    }
    this.dataSet = true;
    this.calData = {};
    this.dataModel = options.dataModel;
    this.launchOverlay = options.launchOverlayCallback;
    this.counterId = options.counterId;
    this.calendarId = 0;
    this.apptDur = options.appointmentDuration;
    this.apptDurWithPadding = options.appointmentDurationWithPadding;
    this.serviceIds = options.serviceIds;
  };

  apptBook.CalendarModel.prototype.update = function (data) {
    if (!this.dataSet || !data) {
      return;
    }
    var me = this;

    this.calData.hilite = data.hilite ? true : false;
    this.calData.apptDur = this.apptDur;
    this.calData.apptDurWithPadding = this.apptDurWithPadding;
    this.calData.currentDate = new Date();
    this.calData.myDate = data.date || this.calData.myDate || this.calData.currentDate;
    this.calendarId = data.calendarId || this.calendarId;
    this.counterId = data.counterId || this.counterId;
    this.serviceIds = data.serviceIds || this.serviceIds;
    this.calData.apptTime = data.appointmentTime;

    this.dataModel.getCounter(
      this.counterId,
      { service_id: this.serviceIds },
      function (countData) {
        var cal,
          cals = countData.calendars;

        if (!cals || !cals.length) {
          me.calData.timeslots = null;
          if (me.launchOverlay && typeof me.launchOverlay === 'function') {
            me.launchOverlay();
          }
        } else {
          for (var i = 0, len = cals.length; i < len; i += 1) {
            cal = cals[i];
            if (parseInt(cal.id, 10) === parseInt(me.calendarId, 10)) {
              me.calData.timeslots = cal.timeslots;
              break;
            }
          }
        }

        me.fire('time_deselected');
        me.dispatchUpdate(me.calData);
      }
    );
  };

  apptBook.CalendarModel.prototype.dispatchUpdate = function (data) {
    this.fire('update', data);
  };

  apptBook.CalendarModel.prototype.getData = function () {
    return this.dataSet ? this.calData : null;
  };

  apptBook.CalendarModel.prototype.setSelection = function (selection) {
    this.selection = selection;
    this.selectionString =
      selection.getFullYear() +
      '-' +
      (selection.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      selection.getDate().toString().padStart(2, '0') +
      ' ' +
      selection.getHours().toString().padStart(2, '0') +
      ':' +
      ('0' + selection.getMinutes()).slice(-2) +
      ':00';

    this.fire('time_selected', this.selectionString);
  };

  apptBook.CalendarModel.prototype.getSelection = function () {
    return {
      selectionDate: this.selection,
      selectionString: this.selectionString
    };
  };

  /**
   * CalendarHeader is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Time Slot Calendar Header.
   *
   *
   * @param header JQuery required    a jquery object that contains a DOM element that represents the root element of the
   *                                  header.
   *
   *
   * @constructor
   */

  apptBook.CalendarHeader = function (header) {
    apptBook.CalendarHeader.superclass.constructor.call(this);
    this.initialized = false;
    this.header = header;
    this.rArrow = this.header.find('.next');
    this.lArrow = this.header.find('.previous');
    this.headContent = this.header.find('.cal-copy');
    this.headDateFormat = this.header.attr('data-cal-week-select-date-format') || '';
    this.headCopy = this.headContent.html();
    this.months = this.header.attr('data-months').split(',');
  };

  ctrlopt.extend(apptBook.CalendarHeader, ctrlopt.mvc.AbstractView);

  apptBook.CalendarHeader.prototype.defaultController = function () {
    return this.controller;
  };

  apptBook.CalendarHeader.prototype.onUpdate = function (data) {
    this.calData = data;
    var headOut,
      me = this,
      myDate = this.calData.myDate,
      dayOfWeek = startDayShift(myDate.getDay()),
      now = new Date(),
      nowDay = startDayShift(now.getDay());

    now.setDate(now.getDate() - nowDay);

    this.firstDay = new Date(myDate.getTime());
    this.firstDay.setDate(this.firstDay.getDate() - dayOfWeek);
    this.firstDay.setHours(0);

    if (this.firstDay > now) {
      this.lArrow.css('visibility', 'visible');
    } else {
      this.lArrow.css('visibility', 'hidden');
    }

    if (this.headDateFormat) {
      headOut = moment(this.firstDay).format(this.headDateFormat);
    } else {
      if (oab_date_time_override) {
        var addDays = new Date(this.firstDay.getTime());

        addDays.setDate(addDays.getDate() + 6);
        addDays = new Date(addDays);
        headOut =
          this.firstDay.getFullYear() +
          this.header.attr('data-year-suffix') +
          ('0' + (this.firstDay.getMonth() + 1)).slice(-2) +
          this.header.attr('data-month-suffix') +
          this.firstDay.getDate() +
          this.header.attr('data-day-suffix') +
          '-' +
          ('0' + (addDays.getMonth() + 1)).slice(-2) +
          this.header.attr('data-month-suffix') +
          addDays.getDate() +
          this.header.attr('data-day-suffix');
      } else if (oab_show_week_last) {
        headOut =
          this.firstDay.getDate() +
          ' ' +
          this.months[this.firstDay.getMonth()] +
          ' ' +
          this.firstDay.getFullYear() +
          ' ' +
          this.headCopy;
      } else if (oab_date_override) {
        headOut =
          this.headCopy +
          ' ' +
          this.firstDay.getDate() +
          ' ' +
          this.months[this.firstDay.getMonth()] +
          ' ' +
          this.firstDay.getFullYear();
      } else if (oab_year_first) {
        headOut =
          this.firstDay.getFullYear() +
          oab_year_suffix +
          ' ' +
          this.months[this.firstDay.getMonth()] +
          oab_month_suffix +
          ' ' +
          this.firstDay.getDate() +
          oab_day_suffix +
          ' ' +
          this.headCopy;
      } else if (oab_date_time_dayname_day_month) {
        headOut =
          this.headCopy +
          ' ' +
          this.firstDay.getDate() +
          ' ' +
          this.months[this.firstDay.getMonth()];
      } else {
        headOut =
          this.headCopy +
          ' ' +
          this.months[this.firstDay.getMonth()] +
          ' ' +
          this.firstDay.getDate() +
          ', ' +
          this.firstDay.getFullYear();
      }
    }

    this.headContent.html(headOut);

    this.lArrow.off('click');
    this.rArrow.off('click');

    this.rArrow.css('cursor', 'pointer').on('click', function (e) {
      e.preventDefault();
      var nextDate = new Date(me.firstDay.getTime());

      nextDate.setDate(nextDate.getDate() + 7);

      me.rArrow.css('cursor', 'default').off('click');
      me.lArrow.css('cursor', 'default').off('click');
      me.model.update({ date: nextDate });
    });

    this.lArrow.css('cursor', 'pointer').on('click', function (e) {
      e.preventDefault();
      var prevDate = new Date(me.firstDay.getTime());

      prevDate.setDate(prevDate.getDate() - 7);

      me.rArrow.css('cursor', 'default').off('click');
      me.lArrow.css('cursor', 'default').off('click');
      me.model.update({ date: prevDate });
    });
  };

  /**
   * CalendarTimeSlots is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Calendar Time Slot Selector.
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalendarTimeSlots = function (options) {
    apptBook.CalendarTimeSlots.superclass.constructor.call(this);
    this.initialized = false;
    this.container = options.container;
    this.colHeads = options.colHeads;
    this.timeSlotRow = options.timeSlotRow;
    this.timeSlotsContainer = options.timeSlotsContainer;
    this.days = options.dayNames;
    this.months = options.monthNames;
    this.slotLabels = options.slotLabels;
    this.calDayOfWeekFormat = options.calDayOfWeekFormat;

    this.slots = [];
    var start_hour_time = this.container.attr('cal-start-hour') || 8;
    var end_hour_time = this.container.attr('cal-end-hour') || 23;
    var time_difference = end_hour_time - start_hour_time;

    for (var i = 0; i <= time_difference; i++) {
      if (time_interval) {
        for (var j = 0, k = 0; j < 60; k++) {
          this.slots.push({ hour: parseInt(start_hour_time) + i + ':' + k * time_interval });
          j = parseInt(j) + parseInt(time_interval);
        }
      } else {
        this.slots.push({ hour: parseInt(start_hour_time) + i });
      }
    }

    for (var i = 0, len = this.slots.length; i < len; i += 1) {
      if (this.slotLabels && this.slotLabels[i]) {
        this.slots[i].label = this.slotLabels[i];
      } else {
        this.slots[i].label = '\xA0';
      }
    }
  };
  ctrlopt.extend(apptBook.CalendarTimeSlots, ctrlopt.mvc.AbstractView);

  apptBook.CalendarTimeSlots.prototype.defaultController = function (data) {
    return null;
  };

  apptBook.CalendarTimeSlots.prototype.onUpdate = function (data) {
    this.calData = data;
    this.buildWeekView();
  };

  apptBook.CalendarTimeSlots.prototype.buildWeekView = function () {
    var hText,
      sText,
      hour,
      row,
      len = 7,
      myDate = this.calData.myDate,
      dayOfWeek = startDayShift(myDate.getDay());

    // this.date = myDate.getDate();
    // this.month = myDate.getMonth();
    // this.year = myDate.getFullYear();
    this.firstDay = new Date(myDate.getTime());
    this.firstDay.setDate(this.firstDay.getDate() - dayOfWeek);
    this.firstDay.setHours(0);
    this.lastDay = new Date(this.firstDay.getTime());
    this.lastDay.setDate(this.lastDay.getDate() + 6);
    this.lastDay.setHours(23, 59, 59, 999);

    for (var i = 0; i < len; i += 1) {
      var myDayDate = new Date(this.firstDay.getTime());

      myDayDate.setDate(myDayDate.getDate() + i);
      if (this.calDayOfWeekFormat) {
        hText = moment(myDayDate).format(this.calDayOfWeekFormat).replace('.', '');
      } else if (kr_day_month_format) {
        hText = this.months[myDayDate.getMonth()] + '/' + myDayDate.getDate() + ' ' + this.days[i];
      } else if (oab_date_time_override) {
        hText = this.days[i] + ' ' + this.months[myDayDate.getMonth()] + '/' + myDayDate.getDate();
      } else if (oab_date_time_dayname_day_month) {
        hText = this.days[i] + ' ' + myDayDate.getDate() + ' ' + this.months[myDayDate.getMonth()];
      } else {
        hText = this.days[i] + ' ' + myDayDate.getDate() + '/' + this.months[myDayDate.getMonth()];
      }
      this.colHeads.eq(i).removeClass('hilite').text(hText);
    }

    if (this.calData.hilite) {
      this.colHeads.eq(dayOfWeek).addClass('hilite');
    }

    this.timeSlotsContainer.empty();
    len = this.slots.length;
    i = 0;
    for (; i < len; i += 1) {
      sText = this.slots[i].label;
      hour = this.slots[i].hour;
      row = this.timeSlotRow.clone();
      row.find('td').attr('data-hour', hour).text(sText);
      this.timeSlotsContainer.append(row);
    }
    this.timeSlotsElems = this.timeSlotsContainer.find('td');
    this.setSlots();

    if (this.calData.apptTime) {
      this.setApptTime();
    }
  };

  apptBook.CalendarTimeSlots.prototype.processSlot = function (start, end) {
    var startIndex,
      myDay = new Date(start.getTime()),
      myDayOfWeek = startDayShift(start.getDay()),
      col = this.timeSlotsContainer.find('.day-' + myDayOfWeek),
      sHrDate = new Date(start.getTime()),
      len = this.slots.length,
      me = this,
      start_hr = start.getHours(),
      start_min = start.getMinutes(),
      startHour;

    if (time_interval) {
      if (time_interval < start_min) {
        startHour = start_hr + 1 + ':0';
      } else if (start_min === 0) {
        startHour = start_hr + ':0';
      } else if (time_interval >= start_min) {
        startHour = start_hr + ':' + time_interval;
      }
    } else {
      startHour = start_min === 0 ? start_hr : start_hr + 1;
    }

    // If the counter/calendar is open BEFORE the defined this.slots hours, then we should just show it as open starting
    // at the first defined time in this.slots
    var splitHour = this.slots[0].hour.toString().split(':');
    var lowestSlotTimeHour = parseFloat(splitHour[0]);
    var lowestSlotTimeMinutes = splitHour[1] ? parseFloat(splitHour[1]) / 60 : 0;
    var lowestSlotTimeFloat = lowestSlotTimeHour + lowestSlotTimeMinutes;
    var startHourFloat = parseFloat(start_hr) + parseFloat(start_min ? start_min / 60 : 0);

    if (startHourFloat < lowestSlotTimeFloat) {
      startIndex = 0;
    } else {
      for (var i = 0; i < len; i += 1) {
        if (this.slots[i].hour === startHour) {
          startIndex = i;
          break;
        }
      }
    }

    for (i = startIndex; i < len; i += 1) {
      var timeLeft,
        minLeft,
        sHr = this.slots[i].hour,
        set_Hr = time_interval ? sHr.split(':')[0] : sHr,
        set_Min = time_interval ? sHr.split(':')[1] : 0;

      sHrDate.setHours(set_Hr, set_Min, 0, 0);
      timeLeft = end.getTime() - sHrDate.getTime();
      minLeft = Math.floor(timeLeft / 60000);

      if (minLeft < this.calData.apptDurWithPadding) {
        break;
      } else {
        col
          .eq(i)
          .addClass('enabled')
          .on('click', function (e) {
            var slotDate = new Date(start.getTime()),
              $this = $(this);

            me.timeSlotsElems.removeClass('selected');
            $(this).addClass('selected');
            slotDate.setHours(parseInt($this.attr('data-hour'), 10));
            var mins = parseInt($this.attr('data-hour').split(':')[1]) || 0;

            slotDate.setMinutes(mins);
            me.model.setSelection(slotDate);
          });
      }
    }
  };

  apptBook.CalendarTimeSlots.prototype.setSlots = function () {
    var timeslots = this.calData.timeslots;

    if (!timeslots) {
      return;
    }

    for (var i = 0, len = timeslots.length; i < len; i += 1) {
      var start = this.convertTimeString(timeslots[i].start_date),
        end = this.convertTimeString(timeslots[i].end_date),
        startTime = start.getTime();

      if (startTime >= this.firstDay.getTime() && startTime <= this.lastDay.getTime()) {
        this.processSlot(start, end);
      }
    }
  };

  apptBook.CalendarTimeSlots.prototype.setApptTime = function () {
    var me = this,
      apptDate = this.convertTimeString(this.calData.apptTime),
      apptTime = apptDate.getTime(),
      apptHour = apptDate.getHours().toString();

    if (apptTime >= this.firstDay.getTime() && apptTime <= this.lastDay.getTime()) {
      this.timeSlotsContainer.find('.day-' + startDayShift(apptDate)).each(function () {
        var $this = $(this);

        if ($this.attr('data-hour') === apptHour) {
          $this.addClass('selected').addClass('enabled');
          me.model.setSelection(apptDate);
        }
      });
    }
  };

  apptBook.CalendarTimeSlots.prototype.convertTimeString = function (tString) {
    var split, dateArray, timeArray, y, m, d, hr, min, sec;

    split = tString.split(' ');
    dateArray = split[0].split('-');
    timeArray = split[1].split(':');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);
    hr = parseInt(timeArray[0], 10);
    min = parseInt(timeArray[1], 10);
    sec = parseInt(timeArray[2], 10);

    return new Date(y, m, d, hr, min, sec);
  };

  /**
   * CalDatePicker is a class faor a concrete controller of the CalendarModel.
   * It manages the pickaday date picker and uses its input to update the Calendar Model
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalDatePicker = function (options) {
    apptBook.CalDatePicker.superclass.constructor.call(this);
    var offSet,
      me = this,
      $bod = options.jqBod,
      overlay = options.overlay,
      closeBtn = options.closeBtn,
      calContainer = options.calContainer,
      weekContainer = options.weekContainer,
      dpField = options.datepickerField,
      dpTrigger = options.datepickerTrigger,
      days = options.dayNames,
      months = options.monthNames,
      year_suffix = options.yearSuffix,
      pikaday = new Pikaday({
        field: dpField[0],
        firstDay: parseInt(start_day),
        minDate: new Date(),
        maxDate: new Date(2020, 12, 31),
        yearRange: [2000, 2020],
        showMonthAfterYear: oab_show_month_after_year ? true : false,
        yearSuffix: oab_show_year_suffix ? year_suffix : '',
        bound: false,
        container: calContainer[0],
        numberOfMonths: 2,
        onSelect: onDateSelect,
        i18n: {
          /* previousMonth : 'Previous Month',
              nextMonth     : 'Next Month',*/
          months: months,
          weekdays: days,
          weekdaysShort: days
        }
      });

    $bod.prepend(overlay);

    function openOverlay() {
      overlay.css('display', 'block');
      pikaday.gotoDate(new Date());
    }

    function closeOverlay() {
      overlay.css('display', 'none');
    }

    function onDateSelect(e) {
      var d = pikaday.getDate();

      if (me.model) {
        me.model.update({
          date: d,
          hilite: true
        });
      }
      closeOverlay();
    }

    dpTrigger.click(openOverlay);
    closeBtn.click(closeOverlay);
    // dpField.change(onDateSelect);
  };

  ctrlopt.extend(apptBook.CalDatePicker, ctrlopt.mvc.AbstractController);

  /* Mobile Appointment Select */

  /* Mobile Date Picker - Date Picker */

  /**
   * CalDatePickerMobile is a sub-class of CalDatePicker. It is a concrete controller of the CalendarModel.
   * It manages the pickaday date picker and uses its input to update the Calendar Model
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalDatePickerMobile = function (options) {
    apptBook.CalDatePickerMobile.superclass.constructor.call(this);
    var me = this,
      calContainer = options.calContainer,
      dpField = options.datepickerField,
      days = options.dayNames,
      months = options.monthNames,
      year_suffix = options.yearSuffix,
      pikaday = new Pikaday({
        field: dpField[0],
        firstDay: parseInt(start_day),
        minDate: new Date(),
        maxDate: new Date(2025, 12, 31),
        yearRange: [2000, 2025],
        showMonthAfterYear: oab_show_month_after_year ? true : false,
        yearSuffix: oab_show_year_suffix ? year_suffix : '',
        bound: false,
        container: calContainer[0],
        onSelect: onDateSelect,
        i18n: {
          /* previousMonth : 'Previous Month',
              nextMonth     : 'Next Month',*/
          months: oab_use_cms_for_mb_calendar_names ? months : moment.localeData()._months,
          weekdays: oab_use_cms_for_mb_calendar_names ? days : moment.localeData()._weekdays,
          weekdaysShort: oab_use_cms_for_mb_calendar_names
            ? days
            : moment.localeData()._weekdaysShort.map(function (shortDay) {
                return shortDay.replace('.', '');
              })
        }
      });

    function onDateSelect(e) {
      var d = pikaday.getDate();

      if (me.model) {
        me.model.update({
          date: d,
          hilite: true
        });
      }
    }
  };

  ctrlopt.extend(apptBook.CalDatePickerMobile, ctrlopt.mvc.AbstractController);

  /* End Mobile Date Picker */

  /* Mobile Calendar Header */

  /**
   * CalendarHeaderMobile is a sub-class of CalendarHeader. It is a concrete view of the CalendarModel.
   * It displays and manages the display logic for the Desktop Time Slot Calendar Header.
   *
   *
   * @param header JQuery required    a jquery object that contains a DOM element that represents the root element of the
   *                                  header.
   *
   *
   * @constructor
   */

  apptBook.CalendarHeaderMobile = function (header) {
    apptBook.CalendarHeaderMobile.superclass.constructor.call(this);
    this.initialized = false;
    this.header = header;
    this.headCopy = this.header.html();
    this.months = this.header.attr('data-months').split(',');
  };

  ctrlopt.extend(apptBook.CalendarHeaderMobile, ctrlopt.mvc.AbstractView);

  apptBook.CalendarHeaderMobile.prototype.onUpdate = function (data) {
    this.calData = data;
    var headOut,
      me = this,
      myDate = this.calData.myDate;

    if (this.headDateFormat) {
      headOut = moment(myDate).format(this.headDateFormat);
    } else {
      if (oab_date_override) {
        headOut = this.headCopy + ' ' + myDate.getDate() + ' ' + this.months[myDate.getMonth()];
      } else if (kr_day_month_format) {
        headOut =
          this.months[myDate.getMonth()] +
          ' ' +
          myDate.getDate() +
          this.header.attr('data-day-suffix') +
          ' ' +
          this.headCopy;
      } else {
        headOut = this.headCopy + ' ' + this.months[myDate.getMonth()] + ' ' + myDate.getDate();
      }
    }

    this.header.html(headOut);
  };

  /* End Mobile Calendar Header */

  /* Mobile Time Slot Select */

  /**
   * CalendarTimeSlotsMobile is a sub-class of CalendarTimeSlots. It is a concrete view of the CalendarModel.
   * It displays and manages the display logic for the Mobile Time Slot Selector.
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalendarTimeSlotsMobile = function (options) {
    apptBook.CalendarTimeSlotsMobile.superclass.constructor.call(this, options);
  };

  ctrlopt.extend(apptBook.CalendarTimeSlotsMobile, apptBook.CalendarTimeSlots);

  apptBook.CalendarTimeSlotsMobile.prototype.onUpdate = function (data) {
    this.calData = data;
    if (!this.initialized) {
      this.buildWeekView();
      this.initialized = true;
    } else {
      this.tdElems.removeClass('selected');
      this.setSlots();
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.buildWeekView = function () {
    var hour, sText, row, rowCount, rows, rowIdx, tds, tdPerRow, tdElem, mod, cur, td;

    tds = this.timeSlotRow.find('td').remove();
    tdPerRow = tds.length;
    tdElem = tds.first();
    rowCount = Math.ceil(this.slots.length / tdPerRow);

    for (var i = 0; i < rowCount; i += 1) {
      row = this.timeSlotRow.clone();
      this.timeSlotsContainer.append(row);
    }

    rows = this.timeSlotsContainer.find('tr');
    i = 0;
    rowIdx = 0;
    for (var len = this.slots.length; i < len; i += 1) {
      sText = this.slots[i].label;
      hour = this.slots[i].hour;
      td = tdElem.clone();
      td.attr('data-hour', hour).text(sText);
      rows.eq(rowIdx).append(td);

      cur = i + 1;
      mod = cur % tdPerRow;

      if (mod === 0) {
        rowIdx += 1;
      }
    }
    this.tdElems = this.timeSlotsContainer.find('td');
    this.setSlots();

    if (this.calData.apptTime) {
      this.setApptTime();
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.processSlot = function (start, end) {
    var startIndex,
      sHrDate = new Date(start.getTime()),
      len = this.slots.length,
      me = this,
      start_hr = start.getHours(),
      start_min = start.getMinutes(),
      startHour;

    if (time_interval) {
      if (time_interval < start_min) {
        startHour = start_hr + 1 + ':0';
      } else if (start_min === 0) {
        startHour = start_hr + ':0';
      } else if (time_interval >= start_min) {
        startHour = start_hr + ':' + time_interval;
      }
    } else {
      startHour = start_min === 0 ? start_hr : start_hr + 1;
    }

    // If the counter/calendar is open BEFORE the defined this.slots hours, then we should just show it as open starting
    // at the first defined time in this.slots
    var splitHour = this.slots[0].hour.toString().split(':');
    var lowestSlotTimeHour = parseFloat(splitHour[0]);
    var lowestSlotTimeMinutes = splitHour[1] ? parseFloat(splitHour[1]) / 60 : 0;
    var lowestSlotTimeFloat = lowestSlotTimeHour + lowestSlotTimeMinutes;
    var startHourFloat = parseFloat(start_hr) + parseFloat(start_min ? start_min / 60 : 0);

    if (startHourFloat < lowestSlotTimeFloat) {
      startIndex = 0;
    } else {
      for (var i = 0; i < len; i += 1) {
        if (this.slots[i].hour === startHour) {
          startIndex = i;
          break;
        }
      }
    }

    for (i = startIndex; i < len; i += 1) {
      var timeLeft,
        minLeft,
        sHr = this.slots[i].hour,
        set_Hr = time_interval ? sHr.split(':')[0] : sHr,
        set_Min = time_interval ? sHr.split(':')[1] : 0;

      sHrDate.setHours(set_Hr, set_Min, 0, 0);
      timeLeft = end.getTime() - sHrDate.getTime();
      minLeft = Math.floor(timeLeft / 60000);

      if (minLeft < this.calData.apptDurWithPadding) {
        break;
      } else {
        this.tdElems
          .eq(i)
          .addClass('enabled')
          .on('click', function (e) {
            var slotDate = new Date(start.getTime()),
              $this = $(this);

            me.tdElems.removeClass('selected');
            $(this).addClass('selected');
            slotDate.setHours(parseInt($this.attr('data-hour'), 10));
            var mins = parseInt($this.attr('data-hour').split(':')[1]) || 0;

            slotDate.setMinutes(mins);
            me.model.setSelection(slotDate);
          });
      }
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.setSlots = function () {
    var timeslots = this.calData.timeslots,
      myDate = new Date(this.calData.myDate.getTime());

    myDate.setHours(0, 0, 0, 0);

    this.tdElems.removeClass('enabled').off('click');

    if (!timeslots) {
      return;
    }
    for (var i = 0, len = timeslots.length; i < len; i += 1) {
      var start = this.convertTimeString(timeslots[i].start_date),
        startDay = new Date(start.getTime());

      startDay.setHours(0, 0, 0, 0);

      if (startDay.getTime() === myDate.getTime()) {
        this.processSlot(start, this.convertTimeString(timeslots[i].end_date));
      }
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.setApptTime = function () {
    var me = this,
      apptDate = this.convertTimeString(this.calData.apptTime),
      apptTime = apptDate.getTime(),
      apptHour = apptDate.getHours().toString();
  };

  /* End Mobile Time Slot Select */

  Drupal.behaviors.apptBookAppointments = {
    attach: function (context) {
      var self = this;
      var view = new apptBook.AppointmentSelectSection($('#appointments'));

      view.setModel(apptBook.sectionModel).startObserving();
      $('.artist-info').on('click', function () {
        $.colorbox.remove();
        $('body', context).removeClass('loyalty_offer_signup');
        var artist_node = $('#appointments', context).attr('data-artist-node');

        $.ajax({
          url: 'https://' + window.location.host + '/elc_api/' + artist_node + '/',
          type: 'GET',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Accept', 'HTML');
          },
          success: function (data) {
            var content =
              '<div class="app-artist-info">' +
              $(
                '#' + artist_node.replace('/', '-') + ' .content .field-elc-nodeblock-content',
                data.rendered
              ).html() +
              '</div>';
            var artistDescLimit = 200;
            var colorboxSettings = {
              html: content,
              close: '<i class="icon--remove"></i>',
              width: site.client.isMobile ? '90%' : '60%',
              transition: 'none',
              opacity: '0.7',
              onComplete: function () {
                var cboxContent = $('#colorbox');

                $('#cboxLoadedContent', cboxContent).css({
                  width: '99%',
                  height: '440px'
                });
                $(cboxContent).addClass('appt-artist-overlay');
                // hide colorbox popup border
                $(cboxContent)
                  .find(
                    '#cboxTopLeft, #cboxTopRight, #cboxBottomLeft, #cboxBottomRight, #cboxMiddleLeft, #cboxMiddleRight, #cboxTopCenter, #cboxBottomCenter'
                  )
                  .addClass('hidden');
                $('.app-artist-info').slick({
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  variableWidth: false,
                  infinite: false,
                  responsive: [
                    {
                      breakpoint: 640,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                        centerMode: true,
                        variableWidth: true
                      }
                    }
                  ]
                });
                $('.artist-description', cboxContent).each(function () {
                  var artistFullDesc = $(this).text();

                  if (artistFullDesc.length > artistDescLimit) {
                    var firstSet = artistFullDesc.substring(0, artistDescLimit);
                    var secondHalf = artistFullDesc.substring(
                      artistDescLimit,
                      artistFullDesc.length
                    );

                    $(this).empty().html(firstSet);
                    $(this).append('<a href="javascript:void(0);" class="read-more">...</a>');
                    $(this).append('<span class="more-text hidden">' + secondHalf + '</span>');
                  }
                });
                $('.read-more', cboxContent).on('click', function () {
                  $(this).parent().find('.more-text').removeClass('hidden');
                  $(this).parent().find('.read-more').addClass('hidden');
                });
                $('.slick-dots li button, .slick-prev, .slick-next', cboxContent).click(
                  function () {
                    $('.artist-description', cboxContent).each(function () {
                      $(this).find('.more-text').addClass('hidden');
                      $(this).find('.read-more').removeClass('hidden');
                    });
                  }
                );
              }
            };
            var colorboxPcSettings = {
              width: '680px',
              height: '440px'
            };
            var colorboxMobileSettings = {
              width: '100%',
              height: '468px',
              left: '18px'
            };
            var overlay = $.extend(
              {},
              colorboxSettings,
              +site.client.isMobile ? colorboxMobileSettings : colorboxPcSettings
            );

            self.openWindow(overlay);
          }
        });
      });
    },
    openWindow: function (overlay) {
      $.colorbox(overlay);
    }
  };
})(jQuery);
